import {
	ADD_EMAIL_FAIL,
	ADD_EMAIL_START, ADD_EMAIL_SUCCESS,
	GET_MESSAGE_FAIL,
	GET_MESSAGE_START,
	GET_MESSAGE_SUCCESS,
	SET_CLOSE_SNACK,
	SET_OPEN_SNACK,
	SET_ROLE,
	SET_TAB,
	SET_LANG,
	SET_THEME, GET_EVENTS_START, GET_EVENTS_SUCCESS, GET_EVENTS_FAIL
} from "./actions/ActionTypes";
import {createAtlantisTheme} from "../styles/theme/AtlantisTheme";


export const initAppState = () => {
	let themeValue = "light";
	/*	if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			themeValue = "dark";
		}*/

	return {
		open: false,
		lang: "it",
		severity: "success",
		message: "",
		tab: 0,
		role: {},
		theme: createAtlantisTheme({type: themeValue}),
		messages: [],
		loadingGetMessages: true,
		errorGetMessages: "",
		loadingSendEmail: true,
		errorSendEmail: "",
		eventi: [],
		loadingGetEventi: true,
		errorGetEventi: "",
	};
}

export const APP_INITIAL_STATE = {}

export const AppReducer = (state = APP_INITIAL_STATE, action) => {
	switch (action.type) {
		case SET_LANG:
			return {
				...state,
				lang: action.payload
			}
		case SET_THEME:
			return {
				...state,
				theme: action.payload,
			}
		case SET_TAB:
			return {
				...state,
				tab: action.payload,
			}
		case SET_ROLE:
			sessionStorage.setItem("role", JSON.stringify(action.payload));
			return {
				...state,
				tab: 0,
				role: action.payload
			}
		case SET_OPEN_SNACK:
			return {
				...state,
				open: true,
				severity: action.severity,
				message: action.message,
			}

		case SET_CLOSE_SNACK:
			return {
				...state,
				open: false,
				// message: "",
			}
		case GET_MESSAGE_START:
			return {
				...state,
				loadingGetMessages: true,
				errorGetMessages: "",
			}
		case GET_MESSAGE_SUCCESS:
			return {
				...state,
				messages: action.payload,
				loadingGetMessages: false,
				errorGetMessages: "",
			}
		case GET_MESSAGE_FAIL:
			return {
				...state,
				messages: [],
				loadingGetMessages: false,
				errorGetMessages: action.error,
			}
		case ADD_EMAIL_START:
			return {
				...state,
				loadingSendEmail: true,
				errorSendEmail: "",
			}
		case ADD_EMAIL_SUCCESS:
			return {
				...state,
				loadingSendEmail: false,
				errorSendEmail: "",
			}
		case ADD_EMAIL_FAIL:
			return {
				...state,
				loadingSendEmail: false,
				errorSendEmail: action.error,
			}
		case GET_EVENTS_START:
			return {
				...state,
				eventi: [],
				loadingGetEventi: true,
				errorGetEventi: "",
			}
		case GET_EVENTS_SUCCESS:
			return {
				...state,
				eventi: action.payload,
				loadingGetEventi: false,
				errorGetEventi: "",
			}
		case GET_EVENTS_FAIL:
			return {
				...state,
				eventi: [],
				loadingGetEventi: false,
				errorGetEventi: action.error,
			}

		default:
			return state;
	}
}
